/**
 * Created by mac on 2019-10-24
 */

cleverapps.Particles = cc.ParticleSystem.extend({
    ctor: function (json, spriteFrame) {
        const data = json.resolve().getJson();

        this._super({ ...data, spriteFrame });
    },

    stop: function (callback) {
        callback = callback || function () {};
        delete this.target;
        this.setAutoRemoveOnFinish(true);
        this.stopSystem();
        this.runAction(new cc.Sequence(
            new cc.DelayTime(3),
            new cc.CallFunc(callback),
            new cc.RemoveSelf()
        ));
    },

    followTarget: function (target) {
        // this.setEmitterMode(cc.ParticleSystem.MODE_RADIUS);
        this.setPositionType(cc.ParticleSystem.TYPE_RELATIVE);
        this.target = target;

        this.updateRelativePosition();

        addCleaner(target, this.createListener(() => {
            if (this.target === target) {
                this.stop();
            }
        }));
    },

    updateRelativePosition: function () {
        if (this.target && this.getParent() && this.target.getParent()) {
            const pos = this.getRelativeCoordinates(this.target);
            this.setAlignment(pos);
        }
    },

    update: function (dt) {
        this.updateRelativePosition();

        this._super(dt);
    },

    visitTextureBundle: function () {
        if (this._texture) {
            cc.rendererBundle = this._texture.bundleName;
        }
    }
});
